<template>
    <Content :title="$t('navigation.persons_groups')">
        <template v-slot:main>
            <EmployeesGroupsTable
                @change-page="changePage($event)"
                @change-amount="changeAmount($event)"
                @sort="sortingColumn = $event"
                @fetch="fetchEmployeesGroups"
                :loader="loader"
                :changed-page="pagination.page"
            />
            <ManageEmployeesGroup @fetch="fetchEmployeesGroups"></ManageEmployeesGroup>
        </template>
    </Content>
</template>

<script>
import EmployeesGroupsTable from '@/components/employeesGroups/EmployeesGroupsTable';
import ManageEmployeesGroup from '@/components/employeesGroups/manageEmployeesGroup/ManageEmployeesGroup';
import Content from '@/components/templates/Content.vue';

export default {
    name: 'EmployeesGroupsConfigurations',
    components: { Content, EmployeesGroupsTable, ManageEmployeesGroup },
    data: () => ({
        loader: false,
        pagination: {
            page: 1,
            amount: 20
        },
        sortingColumn: null
    }),
    watch: {
        sortingColumn: {
            handler () {
                this.fetchEmployeesGroups();
            },
            deep: true
        }
    },
    methods: {
        fetchEmployeesGroups () {
            this.loader = true;

            const params = {
                'page[number]': this.pagination.page,
                'page[size]': this.pagination.amount,
                include: 'employees'
            };

            if (this.sortingColumn) {
                params.sort = this.sortingColumn.value === 'asc' ? this.sortingColumn.name : `-${this.sortingColumn.name}`;
            }

            return this.$store.dispatch('employeesGroups/getEmployeesGroups', params)
                .finally(() => {
                    this.loader = false;
                });
        },
        changePage (event) {
            this.pagination.page = event;
            this.fetchEmployeesGroups();
        },
        changeAmount (event) {
            this.pagination.page = 1;
            this.pagination.amount = event;
            this.fetchEmployeesGroups();
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            if (vm.$can(vm.$abilityActions.READ, vm.$abilitySubjects.EMPLOYEE_GROUP)) {
                vm.fetchEmployeesGroups();
            } else {
                vm.$router.push({ name: 'home' });
            }
        });
    }
};
</script>

<style scoped>

</style>
